// extracted by mini-css-extract-plugin
module.exports = {"header":"Dashboard_header__Bz7dG","search":"Dashboard_search__313e8","tabs":"Dashboard_tabs__3DMhp","wrap":"Dashboard_wrap__1Ukfw"};